import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=7458e788&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7458e788')) {
      api.createRecord('7458e788', component.options)
    } else {
      api.reload('7458e788', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=7458e788&", function () {
      api.rerender('7458e788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/ChangePassword.vue"
export default component.exports